import React from 'react';
import PropTypes from 'prop-types';
import styles from './AspectWheel.module.scss';

export default function AspectWheel(props) {
  const onSectionClick = (sectionValue) => () => {
    props.onToggle(sectionValue);
  };

  const getSectionTextColor = (value) => {
    if (props.disabled) {
      if (sectionOn(value)) {
        return '#272727';
      } else {
        return '#1c1c1d';
      }
    } else {
      return '#fff';
      // if (sectionOn(value)) {
      //   return '#000000';
      // } else {
      //   return '#ffffff';
      // }
    }
  };

  const getSectionColor = (value) => {
    if (props.disabled) {
      if (sectionOn(value)) {
        return '#333';
      } else {
        return '#262627';
      }
    } else {
      if (sectionOn(value)) {
        return '#f37735';
      } else {
        return '#262627';
      }
    }
  };
  
  const sectionOn = (value) => {
    return props.activeValues.includes(value);
  };

  const getSectionClasses = (value) => {
    let classes = [styles.clickableSection];

    if (props.disabled) {
      return [...classes, styles.disabled].join(' ');
    } else {
      return [
        ...classes,
        sectionOn(value) ? styles.active : '',
      ].join(' ');
    }
  };

  return (
    <div className={styles.wheelContainer + ' ' + (props.disabled ? styles.disabledOutline : '')}>
      <svg
        width={248}
        height={248}
        viewBox='0 0 248 248'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
        className={styles.wheelSvg}
      >
        <g clipPath='url(#clip0)'>
          {/* middle circle = 9 */}
          <g id='flat'>
            <circle
              className={getSectionClasses(9)}
              onClick={onSectionClick(9)}
              cx={124}
              cy={124}
              r={52}
              fill={ getSectionColor(9) }
            />
            <path
              style={{ pointerEvents: 'none' }}
              d='M112.399 129H114.243V124.675H118.474V123.129H114.243V120.364H118.922V118.818H112.399V129ZM122.322 118.818H120.522V129H122.322V118.818ZM126.37 129.154C127.568 129.154 128.284 128.592 128.612 127.951H128.672V129H130.402V123.889C130.402 121.871 128.757 121.264 127.3 121.264C125.694 121.264 124.461 121.98 124.063 123.372L125.744 123.611C125.923 123.089 126.43 122.641 127.31 122.641C128.145 122.641 128.602 123.069 128.602 123.82V123.849C128.602 124.366 128.061 124.391 126.713 124.536C125.232 124.695 123.815 125.137 123.815 126.857C123.815 128.359 124.914 129.154 126.37 129.154ZM126.838 127.832C126.087 127.832 125.55 127.489 125.55 126.827C125.55 126.136 126.151 125.848 126.957 125.734C127.429 125.669 128.374 125.55 128.607 125.361V126.261C128.607 127.111 127.921 127.832 126.838 127.832ZM136.025 121.364H134.519V119.534H132.719V121.364H131.635V122.756H132.719V127.001C132.709 128.438 133.753 129.144 135.105 129.104C135.617 129.089 135.97 128.99 136.164 128.925L135.861 127.518C135.762 127.543 135.558 127.588 135.334 127.588C134.882 127.588 134.519 127.429 134.519 126.703V122.756H136.025V121.364Z'
              fill={ getSectionTextColor(9) }
            />
          </g>
          <g id='nw' className={styles.wedgeButton}>
            {/* NW = 8 */}
            <path
              // className={styles.clickableSection + ' ' + (sectionOn(8) ? styles.active : '')}
              className={getSectionClasses(8)}
              onClick={onSectionClick(8)}
              d='M37.4375 35.9136C48.8863 24.6628 62.4173 15.753 77.2727 9.68098L103.589 74.8173C97.2875 77.4325 91.5454 81.2352 86.6767 86.0197C81.8079 90.8042 77.9056 96.479 75.1808 102.734L10.5137 75.2849C16.844 60.5378 25.9887 47.1643 37.4375 35.9136Z'
              fill={ getSectionColor(8) }
            />
            <path
              style={{ pointerEvents: 'none' }}
              d='M58.6351 51.8182H56.8006V58.7585H56.7111L51.9185 51.8182H50.2679V62H52.1124V55.0646H52.1969L56.9945 62H58.6351V51.8182ZM62.7876 62H64.6072L66.6506 54.8558H66.7301L68.7685 62H70.5881L73.4616 51.8182H71.478L69.6435 59.3054H69.554L67.5902 51.8182H65.7855L63.8267 59.3004H63.7322L61.8977 51.8182H59.9141L62.7876 62Z'
              fill={ getSectionTextColor(8) }
            />
          </g>
          <g id='w' className={styles.wedgeButton}>
            {/* W = 7 */}
            <path
              // className={styles.clickableSection + ' ' + (sectionOn(7) ? styles.active : '')}
              className={getSectionClasses(7)}
              onClick={onSectionClick(7)}
              d='M0.504482 122.922C0.644544 106.871 3.91224 91.0033 10.123 76.2054L74.7901 103.655C72.1832 109.96 70.8118 116.71 70.7522 123.535C70.6927 130.361 71.9461 137.133 74.4425 143.483L9.30624 169.8C3.35468 154.896 0.364411 138.973 0.504482 122.922Z'
              fill={ getSectionColor(7) }
            />
            <path
              style={{ pointerEvents: 'none' }}
              d='M24.5992 130H26.4188L28.4621 122.856H28.5416L30.58 130H32.3996L35.2732 119.818H33.2895L31.455 127.306H31.3655L29.4017 119.818H27.597L25.6382 127.301H25.5438L23.7093 119.818H21.7256L24.5992 130Z'
              fill={ getSectionTextColor(7) }
            />
          </g>
          <g id='sw' className={styles.wedgeButton}>
            {/* SW = 6 */}
            <path
              // className={styles.clickableSection + ' ' + (sectionOn(6) ? styles.active : '')}
              className={getSectionClasses(6)}
              onClick={onSectionClick(6)}
              d='M35.9133 210.562C24.6626 199.113 15.7528 185.582 9.68074 170.727L74.817 144.41C77.4323 150.712 81.2349 156.454 86.0194 161.323C90.8039 166.192 96.4788 170.094 102.734 172.819L75.2846 237.486C60.5375 231.155 47.164 222.011 35.9133 210.562Z'
              fill={ getSectionColor(6) }
            />
            <path
              style={{ pointerEvents: 'none' }}
              d='M55.9439 189.617H57.7188C57.6839 187.897 56.2173 186.679 54.0497 186.679C51.9119 186.679 50.3061 187.882 50.3111 189.682C50.3111 191.143 51.3501 191.984 53.0256 192.416L54.1839 192.714C55.2827 192.993 56.0085 193.336 56.0135 194.126C56.0085 194.996 55.1832 195.578 53.9801 195.578C52.8267 195.578 51.9318 195.061 51.8572 193.992H50.0426C50.1172 196.016 51.6236 197.154 53.995 197.154C56.4361 197.154 57.853 195.936 57.858 194.141C57.853 192.376 56.3963 191.571 54.8651 191.208L53.9105 190.969C53.0753 190.771 52.1705 190.418 52.1804 189.567C52.1854 188.802 52.8714 188.24 54.0249 188.24C55.1236 188.24 55.8494 188.752 55.9439 189.617ZM61.6451 197H63.4647L65.508 189.856H65.5875L67.6259 197H69.4455L72.3191 186.818H70.3354L68.5009 194.305H68.4114L66.4476 186.818H64.6429L62.6841 194.3H62.5897L60.7551 186.818H58.7715L61.6451 197Z'
              fill={ getSectionTextColor(6) }
            />
          </g>
          <g id='s' className={styles.wedgeButton}>
            {/* S = 5 */}
            <path
              // className={styles.clickableSection + ' ' + (sectionOn(5) ? styles.active : '')}
              className={getSectionClasses(5)}
              onClick={onSectionClick(5)}
              d='M122.922 247.495C106.871 247.355 91.0032 244.087 76.2053 237.877L103.655 173.209C109.96 175.816 116.709 177.188 123.535 177.247C130.361 177.307 137.133 176.053 143.483 173.557L169.8 238.693C154.896 244.645 138.973 247.635 122.922 247.495Z'
              fill={ getSectionColor(5) }
            />
            <path
              style={{ pointerEvents: 'none' }}
              d='M125.492 217.617H127.267C127.232 215.897 125.765 214.679 123.598 214.679C121.46 214.679 119.854 215.882 119.859 217.682C119.859 219.143 120.898 219.984 122.573 220.416L123.732 220.714C124.831 220.993 125.556 221.336 125.561 222.126C125.556 222.996 124.731 223.578 123.528 223.578C122.375 223.578 121.48 223.061 121.405 221.992H119.59C119.665 224.016 121.171 225.154 123.543 225.154C125.984 225.154 127.401 223.936 127.406 222.141C127.401 220.376 125.944 219.571 124.413 219.208L123.458 218.969C122.623 218.771 121.718 218.418 121.728 217.567C121.733 216.802 122.419 216.24 123.573 216.24C124.671 216.24 125.397 216.752 125.492 217.617Z'
              fill={ getSectionTextColor(5) }
            />
          </g>
          <g id='se' className={styles.wedgeButton}>
            {/* SE = 4 */}
            <path
              // className={styles.clickableSection + ' ' + (sectionOn(4) ? styles.active : '')}
              className={getSectionClasses(4)}
              onClick={onSectionClick(4)}
              d='M210.562 212.086C199.113 223.337 185.582 232.247 170.727 238.319L144.41 173.183C150.712 170.567 156.454 166.765 161.323 161.98C166.192 157.196 170.094 151.521 172.819 145.265L237.486 172.715C231.156 187.462 222.011 200.835 210.562 212.086Z'
              fill={ getSectionColor(4) }
            />
            <path
              style={{ pointerEvents: 'none' }}
              d='M188.24 189.617H190.015C189.98 187.897 188.513 186.679 186.346 186.679C184.208 186.679 182.602 187.882 182.607 189.682C182.607 191.143 183.646 191.984 185.321 192.416L186.48 192.714C187.579 192.993 188.304 193.336 188.309 194.126C188.304 194.996 187.479 195.578 186.276 195.578C185.123 195.578 184.228 195.061 184.153 193.992H182.339C182.413 196.016 183.919 197.154 186.291 197.154C188.732 197.154 190.149 195.936 190.154 194.141C190.149 192.376 188.692 191.571 187.161 191.208L186.206 190.969C185.371 190.771 184.466 190.418 184.476 189.567C184.481 188.802 185.167 188.24 186.321 188.24C187.419 188.24 188.145 188.752 188.24 189.617ZM191.798 197H198.46V195.454H193.643V192.675H198.077V191.129H193.643V188.364H198.42V186.818H191.798V197Z'
              // fill='#333333'
              fill={ getSectionTextColor(4) }
            />
          </g>
          <g id='e' className={styles.wedgeButton}>
            {/* E = 3*/}
            <path
              // className={styles.clickableSection + ' ' + (sectionOn(3) ? styles.active : '')}
              className={getSectionClasses(3)}
              onClick={onSectionClick(3)}
              d='M247.495 125.078C247.355 141.129 244.087 156.997 237.877 171.795L173.209 144.345C175.816 138.04 177.188 131.291 177.247 124.465C177.307 117.639 176.053 110.867 173.557 104.517L238.693 78.2C244.645 93.1041 247.635 109.027 247.495 125.078Z'
              fill={ getSectionColor(3) }
            />
            <path
              style={{ pointerEvents: 'none' }}
              d='M219.752 130H226.414V128.454H221.597V125.675H226.031V124.129H221.597V121.364H226.374V119.818H219.752V130Z'
              fill={ getSectionTextColor(3) }
            />
          </g>
          <g id='ne' className={styles.wedgeButton}>
            {/* NE = 2 */}
            <path
              // className={styles.clickableSection + ' ' + (sectionOn(2) ? styles.active : '')}
              className={getSectionClasses(2)}
              onClick={onSectionClick(2)}
              d='M212.086 37.4377C223.337 48.8865 232.247 62.4176 238.319 77.2729L173.183 103.59C170.567 97.2878 166.765 91.5457 161.98 86.6769C157.196 81.8082 151.521 77.9059 145.265 75.1811L172.715 10.514C187.462 16.8443 200.835 25.9889 212.086 37.4377Z'
              fill={ getSectionColor(2) }
            />
            <path
              style={{ pointerEvents: 'none' }}
              d='M190.931 51.8182H189.097V58.7585H189.007L184.214 51.8182H182.564V62H184.408V55.0646H184.493L189.29 62H190.931V51.8182ZM192.941 62H199.603V60.4538H194.785V57.6747H199.22V56.1286H194.785V53.3643H199.563V51.8182H192.941V62Z'
              fill={ getSectionTextColor(2) }
            />
          </g>
          <g id='n' className={styles.wedgeButton}>
            {/* N = 1 */}
            <path
              // className={styles.clickableSection + ' ' + (sectionOn(1) ? styles.active : '')}
              className={getSectionClasses(1)}
              onClick={onSectionClick(1)}
              d='M125.078 0.504735C141.128 0.644797 156.997 3.9125 171.794 10.1232L144.345 74.7903C138.04 72.1834 131.29 70.812 124.464 70.7525C117.639 70.6929 110.867 71.9463 104.517 74.4427L78.1998 9.30649C93.1038 3.35493 109.027 0.364665 125.078 0.504735Z'
              fill={ getSectionColor(1) }
            />
            <path
              style={{ pointerEvents: 'none' }}
              d='M127.371 22.8181H125.537V29.7584H125.447L120.655 22.8181H119.004V32.9999H120.849V26.0645H120.933L125.731 32.9999H127.371V22.8181Z'
              fill={ getSectionTextColor(1) }
            />
          </g>
        </g>
        <defs>
          <clipPath id='clip0'>
            <rect width={248} height={248} fill='white' />
          </clipPath>
        </defs>
      </svg>
    </div>
  );
}

AspectWheel.propTypes = {
  activeValues: PropTypes.array,
  disabled: PropTypes.bool,
  onToggle: PropTypes.func,
};